export default __webpack_public_path__ + "static/media/Windfury.553f9f4f.jpg";